import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import Demographics from '../../../demographics/Demographics';

export default function DemographicsRoutes() {
    return (
        <>
            <Route
                path='/demographics'
                element={
                    <RequireAdmin>
                        <Demographics />
                    </RequireAdmin>
                }
            />
        </>
    );
}
